import { API_BASE_URL, fetchWithSession, requestJson } from './http';

const progressUrl = (trackerId) => `${API_BASE_URL}/api/v1/progress/${trackerId}`;

export const loadRemoteProgress = async (trackerId) => {
  const response = await fetchWithSession(progressUrl(trackerId));
  if (response.status === 404) return null;
  if (!response.ok) throw new Error(`Unable to load ${trackerId} progress`);
  const payload = await response.json();
  return payload.state;
};

export const saveRemoteProgress = async (trackerId, state) => {
  const payload = await requestJson(progressUrl(trackerId), {
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ state }),
    fallbackMessage: `Unable to save ${trackerId} progress`,
  });
  return payload.state;
};
